/* eslint-disable */
import React, { useState, useContext, useEffect, useRef } from "react";
import "../../screens/invoice/invoice.scss"
// material ui
import { Button, IconButton } from "@material-ui/core";
import Box from '@mui/material/Box';
// localizations
import { withTranslation, useTranslation, Trans } from "react-i18next";
// redux
import { useSelector, useDispatch } from 'react-redux';
import TextField from '@mui/material/TextField';
import { RWebShare } from "react-web-share";
import InputAdornment from '@mui/material/InputAdornment';
import ContentCopyIcon from "../../assets/images/ContentCopyIcon.svg";
import { bindActionCreators } from 'redux';
import QrCodeIcon from '@mui/icons-material/QrCode';
import { RootState } from "../../store/reducers";
import { useParams } from "react-router-dom";
import QRCode from "react-qr-code";

function ShareInvoiceQrcode() {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [fileExt, setFileExt] = useState("png");
  const state = useSelector((state: RootState) => state.appReducer);
  const { userInfo, storeManagerList,paymentMethodPopUp, bookingForm } = state;
  const { slug, id } : any = useParams()
   
  // Check if ID is a number or encrypted
  const isNumericId = !isNaN(Number(id)) && id !== '' && !isNaN(parseFloat(id));
  let encryptedId = id;
  let finalDecodedId = id;
  
  if (isNumericId) {
    // If ID is a number, encrypt it twice for URL
    try {
      encryptedId = btoa(String(id));
      encryptedId = btoa(encryptedId);
    } catch (error) {
      console.error("Error encoding invoice ID:", error);
      encryptedId = id;
    }
    finalDecodedId = id; // Use the number as-is for API calls
  } else {
    // If ID is already encrypted, decode it twice for API calls
    try {
      finalDecodedId = atob(id);
      finalDecodedId = atob(finalDecodedId);
    } catch (error) {
      console.error("Error decoding invoice ID:", error);
      finalDecodedId = id;
    }
    encryptedId = id; // Keep encrypted version for URL
  }
 
  const ref = useRef(null)

  const appDispatch = useDispatch();
  const [url, setUrl] = useState(`${process.env.REACT_APP_BOOKING_URL}/invoice/${encryptedId}`); //appStsate.shareBillUrl

  const handleClickOpenQrCode = () => {
    setOpen(true);
  };
  const handleCloseQrCode = () => {

    appDispatch({
      type: "setShareBillPopup",
      shareBillPopup: false,
      shareBillUrl: `${process.env.REACT_APP_BOOKING_URL}/invoice/${encryptedId}`
      //appState.shareBillUrl
    });
  };

  const onUrlChange = (event:any) => {
    event.preventDefault();
    setUrl(event.target.value);

  };
  useEffect(() => {
    setUrl(`${process.env.REACT_APP_BOOKING_URL}/invoice/${encryptedId}`);  //state.shareBillUrl
  }, []);

  // const handleCopyText = () => {
  //   var copyText = document.getElementById("myInput");
  //   copyText.select();
  //   copyText.setSelectionRange(0, 99999);
  //   navigator.clipboard.writeText(copyText.value);
  // }

  return (
    <React.Fragment>
      
      <div id="mySidenav" className={`shareInvoiceQrcode  ${state.langValue == "ar" ? "shareInvoiceQrcodeArabic" : " "
        }`}>
        {/* <a href="javascript:void(0)" className="closebtn" onClick="closeNav()">&times;</a> */}
        <div className="container-fluid classForQrcodeStyling content px-4 mt-4">
          <div className=" py-3 MscBannerQrcodeInner"> 
          <div className="row px-2  align-items-center  justify-content-center">
          <QRCode value={`${process.env.REACT_APP_BOOKING_URL}/invoice/${encryptedId}`} size={180} />
          </div>
          </div>
          <div className="bottomBtn d-flex justify-content-center">
            <RWebShare
              data={{
                text: "invoice",
                url: url,
                title: `${t("open-order.share-the-bill")}`
              }}
              onClick={() => console.log("shared successfully!")}
            >
              <Button className={` py-2 px-4 shareBtn familysora600  justify-content-center ${state.langValue === "ar" ? " familyGraphikArabic600" : ""
                }`}

              > 
              
              <span><QrCodeIcon/></span> <span className="text-capitalize familysora600 mx-2 pt-1 " >
                
               {t("invoice.share-QR-with-guest")}</span>  </Button>
            </RWebShare>

            {/* <Button onClick={handleCloseQrCode} className={` py-3 px-4 mt-3 deletebtn justify-content-center ${state.langValue === "ar" ? " familyGraphikArabic600" : ""
              }`}

            > <span >{t("open-order.Cancel")}</span>  </Button> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(ShareInvoiceQrcode);